import {
  checkNullObj,
  getDateText,
  getLocalText,
  useDblIntl
} from '@/pages/datalab/utils/utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import React, {useEffect, useLayoutEffect, useMemo, useRef, useState,} from 'react';
import {useUpdateEffect,useDebounceFn, useSetState} from 'ahooks';
import {isEmpty} from 'lodash-es';
import {Bubble, Justify, Radio, Select, SelectOptionWithGroup, Icon, notification} from 'tea-component';
import {connect} from 'dva';
import './index.scss';

import {history, useIntl, useSelector, useLocation, getLocale} from "umi";
import ChartDropdown from '@/pages/datalab/components/CustomComponents/ChartDropdown';
import LineChart from '@/pages/datalab/components/CustomComponents/Chart/components/LineChart';
import AnalysisPieChart from '@/pages/datalab/components/CustomComponents/Chart/components/AnalysisPieChart';
import StackBarChart from '@/pages/datalab/components/CustomComponents/Chart/components/StackBarChart';
import BarChart from '@customComp/Chart/components/BarChart';
import TableAnalytics from '@/pages/datalab/components/CustomComponents/TableAnalytics/index';
import {IAliTableAnalyticsRef} from '@customComp/AliTableAnalytics/types';
import {CHART_SETTINGS_NAMESPACE} from '@/pages/datalab/models/namespaces';
import customDashboatdDownload from '@/pages/datalab/utils/customDownload';
import { ChartType, type TChartType } from '@dbl/core/chart';
import { DateFormatString } from '@dbl/core/date';
import {ChartRef, IChartConfig} from "@customComp/Chart/_config/_interface";
import {namespace as ExplorationNamespace} from "@/pages/datalab/pages/BehaviorAnalysis/ExplorationAnalysis/model";

import ConfirmModal from '@/pages/aigc/pages/Text2SQL/components/RelevantTable/components/ConfirmModal';

import {isSafari} from '@/pages/intelligence/utils/common';
import {getDownloadTaskId} from '@/pages/intelligence/services/download';
import {getBasePath} from '@/utils/utils';
import moment from 'moment';
import MixedChart from '@customComp/Chart/components/MixedChart';
import PortPage from "@/pages/datalab/pages/Multidimensional/Analysis/components/GuideOperation/PortPage";
import NoData from "@/pages/datalab/pages/Multidimensional/Analysis/components/GuideOperation/NoData";
import {AxiosRequestConfig} from "axios";
import { createTokenAwareFunction, ITokenData } from '@dbl/services/common';
import HorizontalBarChart from '@customComp/Chart/components/HorizontalBarChart';
import PercentStackBarChart from '@customComp/Chart/components/PercentStackBarChart';
import {DATALAB_COMPARE_USER_FILTERS} from "@/pages/datalab/components/UserFilter/FilterPanel/constant";
import Loading from '@/pages/dashboard/components/Loading';
import useChartTypeCacheSignature from '@/pages/datalab/pages/Multidimensional/Analysis/hooks/useChartTypeCacheSignature';

type TLowLimitKey = 'en' | 'zh' | 'name';
const lowEnumerate: { [key in TLowLimitKey]: string | number }[] = [
  {
    en: '2,000 Rows',
    zh: '2,000行',
    name: 2000
  },
  {
    en: '5,000 Rows',
    zh: '5,000行',
    name: 5000
  },
  {
    en: '50,000 Rows',
    zh: '50,000行',
    name: 50000
  },
  {
    en: '100,000 Rows',
    zh: '100,000行',
    name: 100000
  },
  {
    en: '1,000,000 Rows',
    zh: '1,000,000行',
    name: 1000000
  }
];
const iframeInfo: {token?: string; dashboardId?: string;} = {};

const downloadWithTokenHttp = createTokenAwareFunction<
  [api: string, params: any, config?: AxiosRequestConfig],
  [api: string, params: any],
  string
>(
  getDownloadTaskId,
  (tokenData: ITokenData, api: string, params: any): [string, any, AxiosRequestConfig?] => {
    iframeInfo.token = tokenData.token;
    iframeInfo.dashboardId = tokenData.dashboardId;
    const newConfig: AxiosRequestConfig = {
      // baseURL: tokenData.origin,
      headers: { Authorization: tokenData.token },
      noAuth: true,
    };
    
    const newParams = {
      ...params,
      game_code: tokenData.gameCode,
      dashboard_id: tokenData.dashboardId,
      system: undefined,
    };
    return [api, newParams, newConfig];
  }
);

export default connect((state: any, ownProps: { namespace: string; }) => {
  const { namespace } = ownProps;
  const { chartData, table, condition, dataTables, dataTableJoinRelations, userPackages, analysisRunning, columnDimensions, columnX, columnUserFilters, hasUserFilters, gameCode, chartType, statisticalMetrics, hashEqualForAnalysis, save_column_infos: saveColumnInfos, mode, rowLimit, trendStatus, analysisRefreshRunning, visibleSearch } = state[namespace];
  
  return {
    chartData,
    condition,
    dataTables,
    dataTableJoinRelations,
    userPackages,
    analysisRunning,
    analysisLoading: state.loading.effects[`${namespace}/getDataAnlysis`],
    analysisRefreshRunning,
    columnDimensions,
    hasUserFilters,
    columnX,
    columnUserFilters,
    table,
    gameCode,
    chartType,
    statisticalMetrics,
    saveColumnInfos,
    hashEqualForAnalysis,
    mode,
    rowLimit,
    trendStatus,
    visibleSearch,
    currentGame: state?.datalab?.currentGame,
  };
})(AnalysisLineChart);

export function AnalysisLineChart(props: any) {
  const {
    saveColumnInfos,
    chartData,
    filtersArr,
    filterCompares,
    namespace,
    columnDimensions,
    columnX,
    columnUserFilters,
    hasUserFilters,
    gameCode,
    table,
    isOnlyShowPie, // 维度没有日期的时候, 是否只显示饼图
    chartType,
    statisticalMetrics,
    // isBigBar,
    // hashEqualForAnalysis,
    rowLimit,
    analysisLoading,
    analysisRefreshRunning,
    condition,
    currentGame,
    compareTimeData,
    trendStatus,
    visibleSearch,
    // newFlag
    mode,
    dispatch,
  } = props;
  const location = useLocation();
  const isFromAdd = location?.query?.from === 'add' || !location?.query?.from;
  const reqParams = useSelector((state: any) => state[namespace]?.reqParams);
  const { dblFormatMessage: chartFormatMessage, isEn } = useDblIntl("chart");
  const tableRef = useRef<IAliTableAnalyticsRef>(null);
  // const [isHover, setIsHover] = useState(false);
  // newChartData是 为了图表中图例名称的中英转换
  // 当前选中的指标
  const [curMetrics, setCurMetrics] = useState<string>(statisticalMetrics || '');
  const [curMetricsName, setCurMetricsName] = useState<string>('');
  const [selectOption, setSelectOption] = useState<SelectOptionWithGroup[]>();
  // 当前选中图表（与页面/顶部 tab 一致）
  const [curChartType, setCurChartType] = useState(chartType || ChartType.StackBar);
  // 图表切换条的渲染类型
  const [chartSwitchRenderType, setChartSwitchRenderType] = useState<ChartType | null>(null);
  const { formatMessage } = useIntl();
  const [rowLimitAssemble, setRowLimitAssemble] = useSetState<Partial<{
    rowLimitModal: boolean;
    rowLimitValue: number;
  }>>({
    rowLimitModal: false,
    rowLimitValue: 2000
  });  // 事件详情
  const [isEvent, setIsEvent] = useState(true);

  // 从 CHART_SETTINGS_NAMESPACE 获取 column_sort_token
  const columnSortToken = useSelector((state: any) => state[CHART_SETTINGS_NAMESPACE]?.column_sort_token);

  const rightChartConfig = useMemo(() => {
    /**
     * 从 右侧面板 取出对图表的设置
     * 场景1: 右侧面板修改配置项后点击确认, 不发起请求, 此时需要从chartsFormData中获取配置项
     * 场景2: 首次进入图表详情页面时, 需要从 saveColumnInfos 中获取配置项
     * 场景3: 先在折线图设置 All Values 保存, 再切换到 事件折线图 设置 show 7 values 保存; 再切换回 折线图, 此时默认None
     * showValues 代表 图表中有多少个点 展示label
     * showValuesIndex 代表 在图表中哪条折线或柱子上展示label;
     * (showValuesIndex 暂时还不可以在右侧面板设置, 需求上是在第一条折线和柱子上展示label)
     * yAxisName 除组合图外，其他图y轴名称
     * yAxisRangeSwitch y轴显示范围开关
     * yAxisRangeSwitch2 组合图次轴 y轴显示范围开关
     */
    const config: IChartConfig = {showValues: 0, showValuesIndexs: [0], yAxisName: '', yAxisRangeSwitch: false, yAxisRangeSwitch2: false, fieldSetting: {}, description: {}, referenceLine: []};
    if (config.description) {
      config.description = Object.keys(config.description).reduce((acc, key) => {
        acc[key] = config?.description?.[key]?.desc;
        return acc;
      }, {});
    }
    
    // 表格排序列宽相关的配置
    if (saveColumnInfos?.saveWidth) {
      config.tableColumnWidths = JSON.parse(saveColumnInfos.saveWidth || '{}');
    }
    config.sorts = saveColumnInfos?.sorts;
    config.pageSize = saveColumnInfos?.savePaginAtion;
    // 如果有tempData, 证明用户改变过状态但未保存, 应该以最新状态为准
    if (saveColumnInfos?.tempData) {
      const {savePaginAtion, sorts, saveWidth} = saveColumnInfos.tempData;
      savePaginAtion && (config.pageSize = savePaginAtion);
      sorts && (config.sorts = sorts);
      saveWidth && (config.tableColumnWidths = JSON.parse(saveWidth || '{}'));
    }
    return config;
  }, [saveColumnInfos, chartType]);

  /** 实际用于渲染的图表类型：chartSwitch 开启时可为 chartSwitchRenderType，否则为 curChartType */
  const displayChartType: TChartType = useMemo(() => {
    const baseChartSwitch = rightChartConfig?.chartSwitch;
    const inSwitchZone = [ChartType.Table, ChartType.Line, ChartType.Bar].includes(curChartType);
    if (baseChartSwitch?.show && inSwitchZone && chartSwitchRenderType !== null) {
      return chartSwitchRenderType;
    }
    return curChartType;
  }, [rightChartConfig?.chartSwitch, curChartType, chartSwitchRenderType]);
  const isChartSwitchCacheEnabled = useMemo(
    () =>
      !!rightChartConfig?.chartSwitch?.show &&
      Array.isArray(rightChartConfig?.chartSwitch?.chartTypes) &&
      rightChartConfig?.chartSwitch?.chartTypes?.length > 1,
    [rightChartConfig?.chartSwitch],
  );
  // 监听 column_sort_token 变化，触发表格列重排
  useUpdateEffect(() => {
    if (!columnSortToken) {
      return;
    }
    const columnSort = rightChartConfig?.column_sort || [];
    if (!columnSort.length) {
      return;
    }
    const orderCodes = columnSort
      .map((item: any) => {
        // 这里需要拼接和后端返回的column_name中的 name相同的字符串
        let column = item?.column_display_cn; // 字段展示名称
        if (item.column === DATALAB_COMPARE_USER_FILTERS) {
          column = DATALAB_COMPARE_USER_FILTERS; // 如果是对照组, 需要是一个特殊字符串
        }
        if (!column) {
          return null;
        }
        const tableCode = item?.table_code;
        return tableCode ? `${tableCode}_${column}` : column;
      })
      .filter((code): code is string => Boolean(code));
    if (orderCodes.length && tableRef.current) {
      tableRef.current.applyColumnOrder(orderCodes);
    }
  }, [columnSortToken, rightChartConfig?.column_sort]);
  
  useEffect(() => {
    // 更新选择的图表类型
    chartType && setCurChartType(chartType);
    setChartSwitchRenderType(null);
  }, [chartType]);
  
  useEffect(() => {
    // 更新选择的指标类型
    statisticalMetrics && setCurMetrics(statisticalMetrics);
  }, [statisticalMetrics]);
  
  const newChartData = useMemo(() => {
    try {
      if (isEmpty(chartData)) return chartData;
      // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars
      const { lineChart, metrics = [], pieChartData, metrics_en = [], columnName, eventLineChartSumData, lineChartSumData, mixedChartData, stackBarChart, axisList, barChart, rankData, mapData, wordCloudData, horizontalBarData, eventLineChart, percentStackBarData } = chartData;
      // [legacy · 重构可删] axisList：后端 axis_list 已废弃，PercentStackBar 用 percentStackBarData.xAxisData
      const dimension = columnName?.filter((v: any) => v?.type === 1);
      
      // 找到第一个aggregate有值的元素, aggregate 主要用于堆叠图的浮窗内部是否显示Total判断.
      const aggregation = columnName?.find((v: any) => v?.aggregate)?.aggregate;
      return {
        lineChart,
        stackBarChart,
        pieChartData,
        barChart,
        eventLineChart,
        mixedChartData,
        aggregation,
        metrics,
        metrics_en,
        dimension,
        axisList, // [legacy · 重构可删]
        rankData,
        columnName,
        mapData,
        wordCloudData,
        horizontalBarData,
        percentStackBarData,
      };
    } catch (e) {
      return chartData;
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartData, gameCode]);

  // eslint-disable-next-line no-nested-ternary
  const metrics = newChartData ? (newChartData.metrics ? newChartData.metrics : []) : [];
  useEffect(() => {
    if (metrics && metrics.length > 0) {
      const options = metrics.map((name: any) =>
        // let metricsName = isEn ? (chartData?.metrics_en?.[index] || name) : name;
        ({
          value: name,
          text: name?.replace(/(t[0-2]_)/, ''), // 指标名称不需要中英文切换展示
        })
      );
      setSelectOption(options);
      const cur = options.find((opt: {value: string;}) => opt.value === curMetrics) || options[0];
      setCurMetricsName(cur?.text);
      setCurMetrics(cur?.value);
      props.dispatch({
        type: `${namespace}/saveMetrics`,
        payload: {
          statisticalMetrics: cur?.value
        },
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metrics, isEn]);
  
  // 取到第一个指标字段信息
  const metricInfo = newChartData?.columnName?.find((opt: {name: string;}) => opt?.name === metrics[0]) || {};

  // 是否隐藏图表
  const {isHideChart, noData} = useMemo(() => {
    if (isEmpty(newChartData)) return { isHideChart: true   };
    switch (chartType) {
      case ChartType.Table: {
        return {
          isHideChart: !table,
          noData: table && (table?.actualCount === 0)
        };
      }
      case ChartType.StackBar: {
        return {
          isHideChart: !newChartData?.stackBarChart,
          noData: isEmpty(newChartData?.stackBarChart?.seriesData),
        };
      }
      case ChartType.Bar: {
        return {
          isHideChart: !newChartData?.barChart,
          noData: isEmpty(newChartData?.barChart?.seriesData),
        };
      }
      case ChartType.Line: {
        return {
          isHideChart: newChartData?.lineChart === undefined,
          noData: isEmpty(newChartData?.lineChart?.seriesData),
        };
      }
      case ChartType.MixedChart: {
        return {
          isHideChart: newChartData?.mixedChartData === undefined,
          noData: isEmpty(newChartData?.mixedChartData),
        };
      }
      case ChartType.EventLine: {
        return {
          isHideChart: newChartData?.eventLineChart === undefined,
          noData: isEmpty(newChartData?.eventLineChart?.seriesData),
        };
      }
      case ChartType.Pie: {
        return {
          isHideChart: newChartData?.pieChartData === undefined,
          noData: isEmpty(newChartData?.pieChartData),
        };
      }
      case ChartType.BigNumber: {
        return {
          isHideChart: chartData.bigNumberChart === undefined,
          noData: !(chartData.bigNumberChart?.length > 0),
        };
      }
      case ChartType.Trend: {
        return {
          isHideChart: chartData.lineData === undefined,
          noData: false,
        };
        // return !chartData.trend_metric || !chartData.lineData;
      }
      case ChartType.DimNumberTrend: {
        return {
          isHideChart: chartData.rankData === undefined,
          noData: isEmpty(chartData.rankData) && isEmpty(chartData?.lineData) && isEmpty(chartData?.trend_metric),
        };
      }
      case ChartType.Map: {
        // TODO 后面增加判断
        return {
          isHideChart: !chartData.mapData, // 没有值 说明加载失败
          noData: false, // 产品要求没有数据也要显示地图, 所以这里一直返回false
        };
      }
      case ChartType.WordCloud: {
        return {
          isHideChart: chartData?.wordCloudData === undefined,
          noData: isEmpty(chartData?.wordCloudData?.data),
        };
      }
      case ChartType.HorizontalBarChart: {
        return {
          isHideChart: !newChartData?.horizontalBarData,
          noData: isEmpty(newChartData?.horizontalBarData),
        };
      }
      case ChartType.PercentStackBar: {
        return {
          isHideChart: !newChartData?.percentStackBarData,
          noData: isEmpty(newChartData?.percentStackBarData?.seriesData),
        };
      }
      default: return {
        isHideChart: true,
        noData: true,
      };

    }
  }, [chartType, newChartData]);
  
  const download = () => {
    // 现在后端下载改为了前端下载，下载内容和表格数据保持一致、
    // 目前只有表格、柱状图、折线图、组合图调用后端接口
    if ([ChartType.Table, ChartType.Bar, ChartType.Line, ChartType.MixedChart].includes(displayChartType)) {
      setRowLimitAssemble({
        rowLimitModal: true
      });
      return;
    }
    // 后端返回什么就下载什么, 不做额外的中英文翻译
    const downLoadConfig = {
      // ...table,
      data: table?.data || [],
      columnName: table?.columnName || [],
    };
    const {name = 'Unnamed chart', nameCn = '未命名图表'} = history?.location?.query || {name: 'Unnamed chart', nameCn: '未命名图表'};
    // 确保 fileName 替换 `% /` 为 `_`
    const fileName = getLocalText(isEn, nameCn, name)?.replace(/[/%]/g, '_');
    customDashboatdDownload(downLoadConfig, fileName, isEn);
  };
  
  const isNoDate = useMemo(() => !columnDimensions.find((dim: any) => dim?.column_type?.toLowerCase() === "date") && isOnlyShowPie, [isOnlyShowPie, columnDimensions]);
  
  const pieChartTitle = useMemo(() => {
    const timeFilter = filtersArr?.filter((item: any) =>  item?.column_type === "date") || [];
    const compareDateFilter = filterCompares?.filter((item: any) =>  item?.column_type === "date") || [];
    const timeRangeVal = [];
    if (timeFilter?.length > 0) {
      const dateType = timeFilter?.[0]?.dateType;
      const dateRange = timeFilter?.[0]?.column_value;
      const from = timeFilter?.[0]?.from;
      // @ts-ignore
      const dateFormat = DateFormatString[timeFilter?.[0]?.to_date_format || 'YYYYMMDD'];
      const timeRange = getDateText({dateType, dateRange, dateFormat, lastCount: timeFilter?.[0]?.lastCount, from});
      timeRangeVal.push(timeRange?.join(' ~ ') || '');
    }
    
    if(compareDateFilter?.length > 0) {
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for(let i=0;i<compareDateFilter.length;i++) {
        const item = compareDateFilter[i];
        const dateType = item?.dateType;
        const dateRange = item?.column_value;
        const from = item?.from;
        // @ts-ignore
        const dateFormat = DateFormatString[item?.to_date_format || 'YYYYMMDD'];
        const timeRange = getDateText({dateType, dateRange, dateFormat, lastCount: item?.lastCount, from});
        timeRangeVal.push(timeRange?.join(' ~ ') || '');
      }
    }
    return timeRangeVal;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filtersArr || {}),JSON.stringify(filterCompares || {})]);

  const {
    filterSignature,
    cacheSignatureMap,
    updateCacheSignature,
    updateCacheSignatureByFilters,
  } = useChartTypeCacheSignature({
    enabled: isChartSwitchCacheEnabled,
    filtersArr,
    table,
    chartData,
    displayChartType,
  });
  
  const chartRef: React.MutableRefObject<ChartRef | null> = useRef(null);
  useLayoutEffect(() => {
    const observer = new ResizeObserver(() => {
      const chart = chartRef?.current?.instance?.();
      chart?.resize();
    });
    
    const targetElement = document.querySelector('.table-analysis-chart');
    targetElement && observer.observe(targetElement as Element);
    return () => {
      observer.disconnect();
    };
  }, [table]);
  
  const resetRowLimitAssemble=()=>{
    setRowLimitAssemble({
      rowLimitModal: false,
      rowLimitValue: 2000
    });
  };
  const { run: handleOnDownLoadModal } = useDebounceFn(
    () => {
      const urlSearchParamsName = history?.location?.query || {};
      const fileName = getLocalText(isEn, urlSearchParamsName?.nameCn, urlSearchParamsName?.name, isEn ? 'Unnamed chart' : '未命名图表');
      const { rowLimit, rowlimit, row_limit } = urlSearchParamsName || {};
      // 替换 `% /` 为 `_`
      openCommonDataLabDownloadPage({
        ...reqParams,
        // 下载类型根据顶部tab选中的类型（图表类型切换中可能修改了chartType参数）
        chart_type: chartType?.replace('Chart', '')?.toLowerCase(), 
        sorts: saveColumnInfos?.tempData?.sorts || saveColumnInfos?.sorts || [],
        language: getLocale(),
        pagesize: Number(rowLimit || rowlimit || row_limit) || rowLimitAssemble.rowLimitValue,
        max_size: Number(rowLimit || rowlimit || row_limit) || rowLimitAssemble.rowLimitValue,
        // TODO:这个name如何定义呢，待和产品确认。如果是add的情况下一天
        "file_name": fileName?.replace(/[/%]/g, '_')
      }).finally(() => {
        resetRowLimitAssemble();
      });
    }, {
      wait: 500
    }
  );
  const isOverLimit =useMemo(()=>
    table?.actualCount >= rowLimit
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ,[analysisLoading,table?.actualCount]);
  // ;
  const metricIsAllPercent = condition?.metrics?.reduce((acc: boolean, item: { column_type: string; }) => acc && item.column_type === 'percent', true);

  // 卡片类型组件把下载放到组件内部
  const isCardType = useMemo(() => [ChartType.Trend,ChartType.BigNumber,ChartType.DimNumberTrend]?.includes(curChartType),[curChartType]);

  const tooltipMinTopPx = visibleSearch ? -300 : -140;

  // eslint-disable-next-line no-nested-ternary
  return isHideChart ? <PortPage /> : (
    noData ? (<NoData />) :
      (
        <div className="table-analysis-chart">
          {!isCardType ? (
            <Justify
              className="table-analysis-justify"
              left={
                namespace === ExplorationNamespace ? (
                  <div className="table-analysis-felx">
                    <div className="table-analysis-title">
                      {chartFormatMessage('statistical_metric')}
                    </div>
                    <Select
                      className="table-analysis-select"
                      appearance="button"
                      matchButtonWidth
                      options={selectOption}
                      value={curMetrics}
                      onChange={(value, context) => {
                        setCurMetricsName(
                          context.option?.text?.toString()
                            ? context.option?.text?.toString()
                            : '',
                        );
                        setCurMetrics(value);
                        props.dispatch({
                          type: `${namespace}/saveMetrics`,
                          payload: {
                            statisticalMetrics: value,
                          },
                        });
                      }}
                      placeholder={chartFormatMessage('select_placeholder')}
                    />
                    <span className={'table-analysis-limit-info'}>
                      {chartFormatMessage('limit_info')}
                    </span>
                    <Bubble dark content={chartFormatMessage('limit_bubble')}>
                      <span className={'table-analysis-felx-limit-info'}>
                        {' '}
                        <SvgIcon type={'alert-circle-action'} />
                      </span>
                    </Bubble>
                  </div>
                ) : (
                  ''
                )
              }
              right={
                <div className="table-analysis-felx">
                  {namespace === ExplorationNamespace ? (
                    <ChartDropdown
                      curChartType={curChartType}
                      isNoDate={isNoDate}
                      onChange={(item: any) => {
                        setCurChartType(item.type);
                        props.dispatch({
                          type: `${namespace}/saveChartType`,
                          payload: {
                            chartType: item.type,
                          },
                        });
                      }}
                    />
                  ) : (
                    ''
                  )}
              
                  {   isOverLimit &&
				      <div className={`table-analysis-rows`}>  <Icon type="warning"  style={{
				        marginBottom: '3px',
				        marginRight: '5px',
				      }}/> {chartFormatMessage('row')}</div>}
                  <Bubble dark content={chartFormatMessage('download')}>
                    <i
                      className="table-analysis-iconbox"
                      onClick={download}
                    >
                      <SvgIcon className="table-analysis-icon" type="download" />
                    </i>
                  </Bubble>
                </div>
              }
            />
          ) : (
            ''
          )}
      
          {curChartType === ChartType.StackBar && (
            <StackBarChart
              tooltipMinTopPx={tooltipMinTopPx}
              chartData={newChartData?.stackBarChart || {}}
              metricInfo={metricInfo}
              // curMetrics={curMetrics}
              // curMetricsName={curMetricsName}
              ref={chartRef}
              // dimensions={newChartData?.dimension || []}
              incrementSum={['sum',"count","distinct"].includes(newChartData?.aggregation)}
              chartConfig={rightChartConfig}
              
              // curMetrics={curMetrics}
              curMetricsName={curMetricsName}
              metricNames={newChartData?.metrics || []}
              // isOnlyOneDimension={columnDimensions?.length <= 1}
              metricIsAllPercent={metricIsAllPercent}
              fieldInfos={newChartData?.columnName}
            />
          )}
          {curChartType === ChartType.PercentStackBar && (
            <PercentStackBarChart
              ref={chartRef}
              chartData={newChartData?.percentStackBarData || []}
              metricInfo={metricInfo}
              metrics={newChartData?.metrics || []}
              dimensions={newChartData?.dimension || []}
              chartConfig={rightChartConfig}
            />
          )}
          {
            curChartType === ChartType.HorizontalBarChart && (
              <HorizontalBarChart
                ref={chartRef}
                chartData={newChartData?.horizontalBarData || []}
                metricNames={metrics || []}
                dimensions={newChartData?.dimension || []}
                chartConfig={rightChartConfig}
                fieldInfos={newChartData?.columnName}
                metricIsAllPercent={metricIsAllPercent}
              />
            )
          }
          {
            analysisRefreshRunning ? <Loading/> : ''
          }
          {displayChartType === ChartType.Bar && !analysisRefreshRunning &&
            (<BarChart
              ref={chartRef}
              tooltipMinTopPx={tooltipMinTopPx}
              chartData={newChartData?.barChart|| {}}
              metricNames={newChartData?.metrics || []}
              isOnlyOneDimension={columnDimensions?.length <= 1}
              metricIsAllPercent={metricIsAllPercent}
              chartConfig={rightChartConfig}
              compareDateCount={compareTimeData.defaultCompareTimes?.length || 0}
              fieldInfos={newChartData?.columnName}
              userFilterControls={hasUserFilters ? columnUserFilters : []}
            />)}
          {displayChartType === ChartType.Line && !analysisRefreshRunning && (
            <LineChart
              chartData={newChartData?.lineChart|| {}}
              ref={chartRef}
              tooltipMinTopPx={tooltipMinTopPx}
              metricNames={newChartData?.metrics || []}
              isOnlyOneDimension={columnDimensions?.length <= 1}
              metricIsAllPercent={metricIsAllPercent}
              chartConfig={rightChartConfig}
              compareDateCount={compareTimeData.defaultCompareTimes?.length || 0}
              fieldInfos={newChartData?.columnName}
              userFilterControls={hasUserFilters ? columnUserFilters : []}
            />
          )}
          {curChartType === ChartType.MixedChart && (
            <MixedChart
              chartData={newChartData?.mixedChartData || {}}
              metricNames={newChartData?.metrics || []}
              ref={chartRef}
              chartConfig={rightChartConfig}
              fieldInfos={newChartData?.columnName}
            />
          )}
          {curChartType === ChartType.EventLine && <LineChart
		      isEvent={isEvent}
            tooltipMinTopPx={tooltipMinTopPx}
		      eventData={chartData?.eventData || []}
		      chartData={newChartData?.eventLineChart || {}}
		      metricNames={newChartData?.metrics || []}
		      ref={chartRef}
	        isOnlyOneDimension={columnDimensions?.length <= 1}
            metricIsAllPercent={metricIsAllPercent}
		      chartConfig={rightChartConfig}
	        compareDateCount={compareTimeData.defaultCompareTimes?.length || 0}
	        fieldInfos={newChartData?.columnName}
	      />}
          {curChartType === ChartType.Pie && <AnalysisPieChart
            {...props}
		        chartData={newChartData?.pieChartData || []}
		        pieChartTitle={pieChartTitle}
		        curMetrics={curMetrics}
            metricInfo={metricInfo}
		        ref={chartRef}
            chartConfig={rightChartConfig}
	      />
          }
          {
            displayChartType === ChartType.Table && !analysisRefreshRunning && <TableAnalytics ref={tableRef} sortable isColumnResize isEn={isEn} table={table} chartConfig={rightChartConfig} saveTableState={(state) => {
              const { pageSize, sorts, columnWidths} = state || {};
              const newInfos = {...saveColumnInfos?.tempData};
              pageSize && (newInfos.savePaginAtion = pageSize);
              sorts && (newInfos.sorts = sorts);
              columnWidths && (newInfos.saveWidth = JSON.stringify(columnWidths));
              props.dispatch({
                type: `${namespace}/save`,
                payload: {
                  save_column_infos: {
                    ...saveColumnInfos,
                    // 临时存储 排序, 分页, 列宽等数据, 保存图表时再放到图表信息中
                    tempData: newInfos
                  }
                },
              });
            }}/>
          }

          <ConfirmModal
            {...{
              visible: rowLimitAssemble.rowLimitModal,
              caption: formatMessage({ id: 'dbl_chart_modal_download_set' }),
              click: handleOnDownLoadModal,
              clone: () => resetRowLimitAssemble(),
              size: 580,
            }}
          >
            <DownLoadModalContent
              {...{
                radioValue: rowLimitAssemble.rowLimitValue,
                handleOnRadioChange: (value) =>
                  setRowLimitAssemble({
                    rowLimitValue: value,
                  }),
              }}
            />
          </ConfirmModal>
        </div>
      )
  );
}

export function checkIsChartDataNull(data: any[]): Boolean {
  if (checkNullObj(data) || data?.length === 0) {
    return true;
  }
  for (const item of data) {
    if (checkNullObj(item)) {
      return true;
    }
  }
  return false;
}
export const openCommonDataLabDownloadPage = async (params: any,apiUrl?: string | undefined) => {
  try {
    const api = apiUrl || '/api/v1/datalab/download_excel';
    if (isSafari()) {
      const page: any = window.open('', '_blank');
      const taskId = await downloadWithTokenHttp(api, params);
      page.location = `${location.origin}${getBasePath()}/datalab/download?entityType=${moment().format('YYYY_MM_DD HH_mm_ss')}&baseSystematicName=${'datalab'}&taskId=${taskId}&isShowMaxDownloadRowsTips${false}${iframeInfo.token ? `&token=${iframeInfo.token}&dashboardId=${iframeInfo.dashboardId}` : ''}`;
    } else {
      const taskId = await downloadWithTokenHttp(api, params);
      window.open(
        `${getBasePath()}/datalab/download?entityType=${moment().format('YYYY_MM_DD HH_mm_ss')}&baseSystematicName=${'datalab'}&taskId=${taskId}&isShowMaxDownloadRowsTips=${false}${iframeInfo.token ? `&token=${iframeInfo.token}&dashboardId=${iframeInfo.dashboardId}` : ''}`,
        '_blank',
      );
    }
  } catch (e) {
    console.warn(e);
  }
};


export const DownLoadModalContent = (
  { handleOnRadioChange, radioValue}: {
    handleOnRadioChange: (...args: any[]) => void;
    radioValue: string | number | undefined;
    isRaw?: boolean;
  }
) => {
  const { formatMessage, locale } = useIntl();

  return (<>
    <div className='low-container-waring'>
      {formatMessage({ id: 'dbl_chart_modal_download_warning' })}
    </div>
    <div className='low-container'>
      <div className='low-container-title'>
        {formatMessage({ id: 'dbl_chart_modal_download_dataSource' })}
      </div>
      <div className='low-container-list'>
        <Radio.Group value={radioValue as string}
          onChange={value => {
            handleOnRadioChange?.(value);
          }}>
          {
            lowEnumerate.map(task => (
              <div key={task.name} className='low-container-item' >
                <Radio name={task.name as string}>{locale === "en-US" ? task.en : task.zh}</Radio>
              </div>
            ))
          }
        </Radio.Group>
      </div>
    </div>
  </>);
};

